import Zaui from '@/include/api';
import CartItem from '@/models/CartItem';
import Observable from '@/include/observable';
import { Model } from '@vuex-orm/core';

export default class Cart extends Model {
  static entity = 'carts';

  get count() {
    let count = this.cartItemCount;

    if(this.readOnly) {
      count = 0;
    }
    return count;
  }

  get readOnly() {
    return (this.bookingId > 0 && !this.isEditing);
  }

  get active() {
    return Cart.store().getters.activeCart;
  }

  findItem(id, type) {
    return CartItem.query().where('cartId', this.id).where('itemId', id).where('type', type).first();
  }

  static fields() {
    return {
      id: this.attr(),
      total: this.number(),
      subTotal: this.number(),
      taxes: this.attr(),
      surcharge: this.attr(),
      guestFee: this.number(),
      isEditing: this.boolean(),

      appliedGiftCerts: this.attr([]),
      appliedPromoCodes: this.attr([]),
      discount: this.attr(),

      dateBooked: this.attr(),
      bookingId: this.number(),
      outstandingBalance: this.number(),

      cartItemCount: this.number(),
      items: this.hasMany(CartItem, 'cartId'),
      cartGuests: this.attr([]),
      cartTransactions: this.attr([]),
      confirmationMessage: this.string(),
      related_oftenBoughtTogether: this.attr()
    };
  }

  static _reloadData(data) {
    let cartId = data.id;
    let items = data.cartItems.map(item => {
      item.cartId = cartId;
      return item;
    });

    Cart.delete(cartId);
    Cart.insert({ data });

    CartItem.delete(record => { return record.cartId === cartId });
    CartItem.insert({ data: items });
  }

  static _apiCall(action, item) {
    Observable.publish(`cart-${action}`);
    Observable.publish(`cart-updating`);

    return Zaui.cart[action](item).then(data => {
      Cart._reloadData(data);
      Observable.publish(`cart-${action}-complete`);
      Observable.publish(`cart-updating-complete`);
      Observable.publish(`cart-reloaded`);
    });
  }

  static load() {
    return Zaui.cart.load().then(data => {
      Cart._reloadData(data);
      Cart.store().dispatch('setActiveCartId', data.id);
    });
  }

  static loadBooking(bookingId, be) {
    return Zaui.cart.loadBooking(bookingId, be).then(data => {
      Cart._reloadData(data);
    });
  }

  static add(item) {
    return Cart._apiCall('add', item);
  }

  static update(item) {
    return Cart._apiCall('update', item);
  }

  static remove(item) {
    return Cart._apiCall('remove', item);
  }

  static addGuest(guest) {
    return Zaui.cart.addGuest(guest);
  }

  static complete(payment) {
    return Zaui.cart.complete(payment);
  }

  static applyPromoCode(promoCode){
    return Zaui.cart.applyPromoCode(promoCode);
  }

  static applyGiftCert(giftCert){
    return Zaui.cart.applyGiftCert(giftCert);
  }

}
